import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import ArrowIcon from "../../UI/Icons/ArrowIcon";
import SearchIcon from "../../UI/Icons/SearchIcon";
import Step from "./Step";
import MobileSidebar from "./MobileSidebar";
import { device, priceFormatted } from "../../../utils/helpers";

const Wrapper = styled.div`
  display: none;

  @media ${device.tablet} {
    display: inline-flex;
    flex-direction: column;
    max-width: 21.875vw;
    position: fixed;
    top: 90px;
    bottom: 0;
    right: 0;
    overflow: auto;
  }

  @media ${device.desktop} {
    top: 100px;
  }
`;

const Header = styled.div`
  background: ${props => props.theme.color.bgYellow};
  padding: 10px 20px;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: ${props => (props.collapsed ? "center" : "initial")};

  @media ${device.tablet} {
    ${"" /* width: ${props => !props.collapsed && '21.875vw'}; */}
    width: ${props => !props.collapsed && "17.9vw"};
    height: 6.770833333333334vw;
    flex-basis: 12%;
  }
`;

const Items = styled.div`
  background-color: #f3f3f3;

  @media ${device.tablet} {
    position: relative;
    overflow: auto;
    flex-basis: 88%;
  }
`;

const Footer = styled.div`
  display: flex;
  flex-direction: column;
  text-transform: uppercase;
`;

const Total = styled.div`
  background-color: #fca317;
  font-size: 18px;
  font-family: "BarlowExtraBold";
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: ${props => (props.collapsed ? "center" : "space-between")};
  padding: 15px 30px;

  @media ${device.tablet} {
    font-size: 1.25vw;
  }
`;

const Prices = styled.div`
  background-color: #999999;
  font-size: 12px;
  font-family: "BarlowExtraBold";
  padding: 20px 30px;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: ${props => (props.collapsed ? "center" : "initial")};

  @media ${device.tablet} {
    font-size: 0.9375vw;
  }
`;

const Price = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding-bottom: 15px;
`;

const Arrow = styled(ArrowIcon)`
  cursor: pointer;
  width: 22px;

  @media ${device.tablet} {
    width: 1.1458333333333335vw;
  }
`;

const Search = styled(SearchIcon)`
  width: 30px;

  @media ${device.tablet} {
    width: 1.5625vw;
  }
`;

const Title = styled.h3`
  font-family: "BarlowExtraBold";
  font-size: 1.875vw;
  color: #fff;
`;

class CalculatorSidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: props.collapsed // Whether sidebar is collapsed or not
    };
  }

  componentDidMount() {
    // Callback to parent component to update width
    this.props.isCollapsed(this.state.collapsed);
  }

  toggleSidebar() {
    this.setState({ collapsed: !this.state.collapsed });
    this.props.isCollapsed(!this.state.collapsed);
  }

  render() {
    const { collapsed } = this.state;
    const { steps, total, net, tax, coefficient } = this.props;
    return (
      <React.Fragment>
        <Wrapper>
          <Header collapsed={collapsed}>
            <Arrow
              onClick={this.toggleSidebar.bind(this)}
              transform={collapsed ? "rotate(180) translate(0, 22)" : undefined}
              fill="#4d4d4d"
            />
            {collapsed ? (
              <Search fill="#fff" />
            ) : (
              <div style={{ marginTop: "5px" }}>
                <Title>DETTAGLI</Title>
                <Title>DEL NOLEGGIO</Title>
              </div>
            )}
          </Header>
          <Items>
            {steps.map(
              ({
                index,
                name,
                active,
                visited,
                price,
                components,
                selectedComponent,
                path
              }) => (
                <Step
                  key={index}
                  index={index}
                  name={!collapsed && name}
                  active={active}
                  visited={visited}
                  price={
                    !collapsed && (price && index !== 5
                      ? priceFormatted(Math.round(price + price * coefficient))
                      // ? priceFormatted(200)
                      : priceFormatted(price)
                        // priceFormatted(price)
                    )
                  }
                  components={!collapsed && components}
                  selectedComponent={selectedComponent}
                  collapsed={collapsed}
                  path={path}
                />
              )
            )}
          </Items>
          <Footer>
            <Total collapsed={collapsed}>
              {collapsed ? (
                <p>TOT</p>
              ) : (
                <React.Fragment>
                  <p>TOTALE</p>
                  <p>{priceFormatted(total)}</p>
                  {/* <p>{priceFormatted(total + total * coefficient)}</p> */}
                </React.Fragment>
              )}
            </Total>
            <Prices collapsed={collapsed}>
              {collapsed ? (
                <Title>€</Title>
              ) : (
                <React.Fragment>
                  <Price>
                    <p>TOTALE NETTO</p>
                    <p>{priceFormatted(net)}</p>
                    {/* <p>{priceFormatted(net + net * coefficient)}</p> */}
                  </Price>
                  <Price>
                    <p>IVA 22.00%</p>
                    {/* <p>{priceFormatted(tax + tax * coefficient)}</p> */}
                    <p>{priceFormatted(tax)}</p>
                  </Price>
                </React.Fragment>
              )}
            </Prices>
          </Footer>
        </Wrapper>
        <MobileSidebar collapsed={collapsed} />
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    steps: state.calculator.steps,
    total: state.calculator.total,
    net: state.calculator.net,
    tax: state.calculator.tax,
    coefficient: state.calculator.coefficient,
    average: state.calculator.average
  };
}

export default connect(mapStateToProps)(CalculatorSidebar);



// WEBPACK FOOTER //
// ./src/components/Calculator/Sidebar/index.js